module.exports = __webpack_public_path__ + "img/femaleBrown.df32ab84.png";